<template>
  <div class="form-group" :class="computedClasses">
      <!-- :class="{'vs--selected': val}"  -->
      <!-- v-if="optionsList.length > 0" -->
      <v-select
          class="city-select"
          :class="[inputClasses, {'vs--selected': hasValue}]"
          :name="name"
          :inputId="id"
          :label="label"
          :autocomplete="autocomplete"
          :placeholder="placeholder"
          :filterable="filterable"
          :options="optionsList"
          :clearable="clearable"
          :searchable="searchable"
          :multiple="multiple"
          :reduce="reduceItem"
          :noDrop="noDrop"
          :disabled="disabled"
          :resetOnOptionsChange="resetOnOptionsChange"

          v-model="valueCopy"

          @input="handleModelInput"
          @search:focus="handleFocus(true)"
          @search:blur="handleFocus(false)"
      >
        <template v-slot:selected-option="option">
          <slot name="selected-option" :option="option" :label="label">
            {{ label in option ? option[label] : '' }}
          </slot>
        </template>
        <template v-slot:option="option">
          <slot name="option" :option="option" :label="label">
            {{ 'label' in option ? option['label'] : (label in option ? option[label] : '') }}
          </slot>
        </template>
          <!-- <template slot="no-options">
              Tipo não encontrado
          </template> -->
      </v-select>
      <!-- <v-select v-else class="city-select"></v-select> -->
      <label class="material-label" :class="activeClass" :for="id">
        <slot></slot>
      </label>
      <HelpSpan :helpText="helpText" />
      <small v-if="error" class="invalid-feedback">{{ error }}</small>
  </div>
</template>


<script>
  export default {
    name: 'material-select',
    components: {
        HelpSpan: () => import(/* webpackChunkName: "help-span" */ '@/components/form/HelpSpan.vue'),
    },
    data () {
      return {
        valueCopy: null,
        focus: false,
        valid: true,
        treeData: []
      }
    },
    computed: {
      optionsList() {
        if(this.indentText) return this.hasChild(this.options)
        return this.options;
      },
      computedErrors () {
        return typeof this.errorMessages === 'string'
          ? [this.errorMessages] : this.errorMessages
      },
      computedClasses () {
        return {
          'material--active': this.focus,
          'material--disabled': this.disabled,
          'material--has-errors': Boolean(
            !this.valid ||
            (this.errorMessages && this.errorMessages.length)),
          'material--raised': Boolean(
            this.focus ||
            this.hasValue || // has value
            (this.placeholder && !this.hasValue)), // has placeholder
        }
      },
      activeClass () {
        return {
          'active': Boolean(
            this.focus ||
            this.hasValue || // has value
            (this.placeholder && !this.hasValue)) // has placeholder
        }
      },
      hasValue () {
        return this.multiple ? this.valueCopy!=null && this.valueCopy.length>0 : !this.idNull;
      },
      idNull() {
        return this.valueCopy === undefined || this.valueCopy === null;
      },
      reduceItem (option) {
        if(this.reduceObject){
          return option => option;
        }
        return this.reduce;
      },
    },
    beforeMount () {
      this.copyValue(this.value)
    },
    mounted() {

    },
    methods: {
      hasChild(options) {
        let leftover = [];
        options.forEach(item => {
            if(this.indentationTarget) {
              if(!this.indentationTarget ||  this.indentationTarget in item && item[this.indentationTarget] == null) {
                this.treeData.push({...item, ...{level: 1}});
              } else {
                let parent = this.indentationTarget in item ? this.searchParent(item[this.indentationTarget]) : null;
                if(!parent) {
                  leftover.push(item);
                } else {
                  this.addLeftSpace(parent, item)
                }
              }
            }
          });

        if(leftover.length > 0) this.hasChild(leftover);

        return this.treeData
      },
      searchParent(parent_id) {
        return this.treeData.find(item => { return item.id === parent_id});
      },
      addLeftSpace(parent, item) {
        let level = parent.level + 1
        item.label = '\xa0'.repeat(2 * level) + item.name
        let position = this.treeData.indexOf(parent)
        this.treeData.splice(position + 1, 0, {...item, ...{ level }})
      },
      handleModelInput (value) {
        this.$emit('input', value)
        this.handleValidation()
      },
      handleFocus (focused) {
        this.focus = focused
      },
      handleValidation () {
        this.valid = true; //this.$el ? this.$el.querySelector('.city-select').validity.valid : this.valid
      },
      copyValue (value) {
        // let _val = value;
        // if(this.multiple){
        //   _val = _val.map( option => this.reduceItem(option));
        // }else{
        //   _val = this.reduceItem(_val);
        // }
        this.valueCopy = value;
        this.handleValidation()
      },
    },
    watch: {
      value: {
        deep: true, // "deep" por causa do multiple que é um array
        handler: function(newValue) {
          // This watch works from the code side of the 2-way-binding:
          this.copyValue(newValue);
        }
      }
    },
    props: {
      id: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null
      },
      value: {
        default: null
      },
      options: {
        type: Array,
        default() {
            return [];
        }
      },
      label: {
        type: String,
        default: "label"
      },
      placeholder: {
        type: String,
        default: ""
      },
      disabled: {
        type: Boolean,
        default: false
      },
      clearable: {
        type: Boolean,
        default: true
      },
      searchable: {
        type: Boolean,
        default: true
      },
      multiple: {
        type: Boolean,
        default: false
      },
      filterable: {
        type: Boolean,
        default: true
      },
      reduce: {
        type: Function,
        default: option => option.id,
      },
      reduceObject: {
        type: Boolean,
        default: false
      },
      noDrop: {
        type: Boolean,
        default: false
      },
      inputId: {
        type: String
      },
      resetOnOptionsChange: {
        type: [Boolean, Function],
        default: false
      },
      required: {
        type: Boolean,
        default: false
      },
      autocomplete: {
        type: String,
        default: 'off'
      },
      errorMessages: {
        type: [Array, String],
        default: null
      },
      inputClasses: {
        type: [Array, Object, String],
        default: null
      },
      error: {
        type: String,
        default: null
      },
      helpText: {
        type: String,
        default: null
      },
      indentText: {
        type: Boolean,
        default: false
      },
      indentationTarget: {
        type: String,
        default: null
      }
    }
  }
</script>

<style scoped lang="scss">
</style>